module.exports = __webpack_public_path__ + "static/media/map-marker-alt.2f0e1586.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/map-marker-alt.svg
// module id = 471
// module chunks = 0